<template>
  <div class="ticket-entry-container" v-loading="state.loading">
    <!-- 头部导航 -->
    <header class="header">
      <h1 class="title">票码核销</h1>
      <div class="header-right"></div>
    </header>

    <!-- 未找到内容的提醒界面 -->
    <div v-if="state.notFound" class="not-found-container">
      <div class="not-found-icon">
        <svg
          width="80"
          height="80"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="10" stroke="#ccc" stroke-width="2" />
          <path
            d="M8 8L16 16"
            stroke="#ccc"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M16 8L8 16"
            stroke="#ccc"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <h2 class="not-found-title">未找到订单信息</h2>
      <p class="not-found-desc">请检查链接是否正确，或联系客服咨询</p>
      <button class="btn btn-primary" @click="handleBack">返回首页</button>
    </div>

    <!-- 订单信息内容 -->
    <template v-else>
      <!-- 总览信息 -->
      <div class="info-card">
        <div class="info-item">
          <div class="info-label">订单数量</div>
          <div class="info-value">{{ state.orderInfo.length }} 个订单</div>
        </div>
      </div>

      <!-- 票码列表 -->
      <div class="ticket-list">
        <div 
          v-for="(order, index) in state.orderInfo" 
          :key="index" 
          class="ticket-item"
        >
          <!-- 左边：票面信息 -->
          <div class="ticket-info-left">
            <div class="ticket-title">
              <span class="title-text">{{ order.Mxs?.[0]?.SpMc || "-" }}</span>
              <span 
                class="status-tag" 
                :class="getStatusClass(order.OTAStatus)"
              >
                {{ getStatusText(order.OTAStatus) }}
              </span>
              <span 
                v-if="order.Zt?.Key != 4 && order.OTAStatus == 0 && order.Ly == 3"
                class="refund-btn"
                @click="openRefundDialog(order)"
              >
                退票
              </span>
            </div>
            <div class="ticket-detail">
              <div class="detail-item">
                <span class="label">下单日期</span>
                <span class="value">{{ formatDate(order.Mxs?.[0]?.Syrq || "-") }}</span>
              </div>
              <div class="detail-item">
                <span class="label">入园地址：</span>
                <span class="value">{{ order.Mxs?.[0]?.spdz || "-" }}</span>
              </div>
              <div class="detail-item">
                <span class="label">订单编号：</span>
                <span class="value">{{ order.Bh || "-" }}</span>
              </div>
            </div>
          </div>
          
          <!-- 右边：票码 -->
          <div class="ticket-info-right">
            <div 
              class="ticket-code" 
              @click="state.enlargedTicket = order"
            >
              <div class="code-label">票码</div>
              <div class="code-content">
                <img 
                  v-if="order.OTAQrcodeUrl" 
                  :src="order.OTAQrcodeUrl" 
                  alt="票码" 
                  class="ticket-qrcode"
                />
                <div v-else class="code-placeholder">加载中...</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 票码放大弹窗 -->
      <div v-if="state.enlargedTicket" class="ticket-enlarge-modal" @click="state.enlargedTicket = null">
        <div class="enlarge-content" @click.stop>
          <div class="enlarge-header">
            <div class="enlarge-title">票码详情</div>
            <el-icon 
              class="enlarge-close-icon" 
              @click="state.enlargedTicket = null"
            >
              <Close />
            </el-icon>
          </div>
          <div class="enlarge-qrcode">
            <img 
              v-if="state.enlargedTicket.OTAQrcodeUrl" 
              :src="state.enlargedTicket.OTAQrcodeUrl" 
              alt="放大票码" 
            />
          </div>
          <div class="enlarge-close" @click="state.enlargedTicket = null">关闭</div>
        </div>
      </div>
    </template>
  </div>

  <!-- 取消订单弹窗 -->
  <el-dialog v-model="state.showCancelDialog" title="取消订单">
    <el-input
      type="textarea"
      v-model="state.qxBz"
      :autosize="{ minRows: 5 }"
      placeholder="请输入取消原因"
    ></el-input>
    <template #footer>
      <el-button type="primary" @click="onCancel()" style="padding: 0;width:80px">确认取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { shangpindingdan_itemsAny,shangpindingdan_detailShort,shangpindingdan_cancelAny } from "@/http/api";
import { dayjs } from "element-plus";
import { Close } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
export default {
  name: "H5TicketShortLink",
  setup() {
    const route = useRoute();
    const query = reactive({});
    const router = useRouter();
    const state = reactive({
      loading: false,
      notFound: false,
      qrCodeUrl: "", // 二维码图片URL
      qrCodeSize: 200, // 二维码大小
      orderInfo: [],
      shareUrl: "", // 分享链接
      enlargedTicket: null, // 用于存储当前放大的票码信息
      showCancelDialog: false, // 取消订单弹窗显示状态
      qxBz: "", // 取消原因
      currentOrder: null, // 当前操作的订单
    });

    const copySuccess = ref(false);

    // 获取订单详情
    const loadOrderDetail = async () => {
      state.loading = true;
      console.log("API请求参数:", route.params.code);
      var shortCode=route.params.code
      if(shortCode.length>=6 || shortCode.length<9)
      {
         shangpindingdan_detailShort(shortCode)
        .then((res) => {
          console.log("API响应状态:", res.status);
          console.log("API响应数据:", res.data);
          if (res.status === 200 && res.data && Array.isArray(res.data)) {
            // 直接赋值为数组
            state.orderInfo = res.data;
            console.log("设置订单数据后:", state.orderInfo);
            // 为每个订单计算总金额
            state.orderInfo.forEach(order => {
              order.TotalPrice = order.Mxs?.reduce((sum, item) => {
                return sum + (item.Xsdj || 0) * (item.Sl || 0);
              }, 0) || 0;
            });
            // 如果有订单，使用第一个订单的二维码作为默认展示
            if (state.orderInfo.length > 0) {
              state.shareUrl = state.orderInfo[0].OTAQrcodeUrl;
              generateQRCode();
            }
          } else {
            // 未找到订单信息
            state.notFound = true;
          }
        })
        .catch((error) => {
          console.error("API请求错误:", error);
          state.notFound = true;
        })
        .finally(() => {
          state.loading = false;
        });
      }
      else if(shortCode.length==11)
      {
        shangpindingdan_itemsAny(route.params.code, query.ph, query._t)
          .then((res) => {
            console.log("API响应状态:", res.status);
            console.log("API响应数据:", res.data);
            if (res.status === 200 && res.data && Array.isArray(res.data)) {
              // 直接赋值为数组
              state.orderInfo = res.data;
              console.log("设置订单数据后:", state.orderInfo);
              // 为每个订单计算总金额
              state.orderInfo.forEach(order => {
                order.TotalPrice = order.Mxs?.reduce((sum, item) => {
                  return sum + (item.Xsdj || 0) * (item.Sl || 0);
                }, 0) || 0;
              });
              // 如果有订单，使用第一个订单的二维码作为默认展示
              if (state.orderInfo.length > 0) {
                state.shareUrl = state.orderInfo[0].OTAQrcodeUrl;
                generateQRCode();
              }
            } else {
              // 未找到订单信息
              state.notFound = true;
            }
          })
          .catch((error) => {
            console.error("API请求错误:", error);
            state.notFound = true;
          })
          .finally(() => {
            state.loading = false;
          });
      }
    };

    // 生成二维码
    const generateQRCode = async () => {
      try {
        state.qrCodeUrl = state.shareUrl;
      } catch (error) {
        console.error("生成二维码失败:", error);
        // 实际项目中应该有错误处理逻辑
      }
    };

    // 返回上一页
    const handleBack = () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        // 没有历史记录时跳转到首页
        router.push({
          path: "/h5/sp"
        });
      }
    };

    // 参与调研
    const handleSurvey = () => {
      console.log("参与调研功能");
      // 实际项目中可以跳转到调研页面
    };

    // 格式化日期
    const formatDate = (dateStr) => {
      return dateStr ? dayjs(dateStr).format("YYYY-MM-DD HH:mm") : "-";
    };
    
    // 获取状态文本
    const getStatusText = (status) => {
      switch (status) {
        case 100001:
        case 100000:
        case 0:
          return "未使用";
        case 100002:
          return "部分使用";
        case 100003:
          return "完全使用";
        case 100004:
          return "已作废";
        default:
          return "未知状态";
      }
    };
    
    // 获取状态样式类
    const getStatusClass = (status) => {
      switch (status) {
        case 100001:
        case 100000:
        case 0:
          return "status-unused";
        case 100002:
          return "status-partial";
        case 100003:
          return "status-used";
        case 100004:
          return "status-unknown";
        default:
          return "status-unknown";
      }
    };

    // 打开退票弹框
    const openRefundDialog = (order) => {
      if (order.OTAStatus === 0) {
        state.currentOrder = order;
        state.showCancelDialog = true;
      }
    };

    // 确认退票
    const onCancel = () => {
      if (state.currentOrder && state.currentOrder.OTAStatus === 0) {
      shangpindingdan_cancelAny(route.params.code, state.qxBz).then((res) => {
        ElMessage({
          message: res.data,
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: res.status ? "success" : "error",
        });

        if (res.status == 200) {
          loadOrderDetail();
          state.showCancelDialog = false;
        }
      });
      }
    };

    // 页面加载时生成二维码
    onMounted(() => {
       query.ph = route.query.ph;
      query._t = route.query._t;
      loadOrderDetail();

      // 适配不同屏幕大小的二维码尺寸
      const updateQrCodeSize = () => {
        const screenWidth = window.innerWidth;
        // 确保二维码在各种屏幕上都有合适的大小
        state.qrCodeSize = Math.min(screenWidth * 0.6, 240);
      };

      // 初始化二维码大小
      updateQrCodeSize();

      // 监听窗口大小变化
      window.addEventListener("resize", updateQrCodeSize);

      // 清理事件监听
      return () => {
        window.removeEventListener("resize", updateQrCodeSize);
      };
    });

    return {
      state,
      copySuccess,
      handleBack,
      handleSurvey,
      formatDate,
      getStatusClass,
      getStatusText,
      openRefundDialog,
      onCancel,
      Close,
    };
  },
};
</script>

<style scoped>
/* CSS变量定义 - 便于主题管理 */
:root {
  --primary-color: #ff9500;
  --primary-dark: #e68600;
  --secondary-color: #f5f5f5;
  --text-primary: #333333;
  --text-secondary: #666666;
  --text-tertiary: #999999;
  --success-color: #4cd964;
  --warning-color: #ffcc00;
  --danger-color: #ff3b30;
  --border-radius: 12px;
  --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-medium: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* 全局样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.ticket-entry-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  background-color: var(--secondary-color);
  min-height: 100vh;
  padding-bottom: 80px;
  overflow-x: hidden;
  overflow-y: auto; /* 明确允许垂直滚动 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling: touch;
  height: 100vh; /* 确保容器高度为视口高度 */
  position: relative;
}

/* 头部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.back-btn {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.back-btn:active {
  background-color: var(--secondary-color);
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 auto;
  width: 200px;
  text-align: center;
}

.header-right {
  width: 40px; /* 为了保持标题居中 */
}

/* 未找到内容界面 */
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.not-found-icon {
  margin-bottom: 24px;
}

.not-found-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.not-found-desc {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 32px;
  line-height: 1.5;
}

/* 信息卡片基础样式 */
.info-card {
  margin-top: 12px;
  background-color: white;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow-light);
  animation: fadeIn 0.3s ease-out;
}

/* 入园码区域 */
.entry-code-section {
  margin: 16px;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-light);
  animation: fadeIn 0.3s ease-out 0.1s both;
}

.code-container {
  position: relative;
}

/* 二维码容器 */
.qrcode-container {
  display: flex;
  justify-content: center;
}

.qrcode-wrapper {
  position: relative;
  background-color: white;
  padding: 16px;
  border-radius: 12px;
  box-shadow: var(--shadow-medium);
  transition: transform 0.3s ease;
  border: 1px solid #f0f0f0;
}

.qrcode-wrapper:active {
  transform: scale(0.98);
}

.qrcode-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code-image {
  border: 1px solid #eeeeee;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.qrcode-footer {
  margin-top: 16px;
  text-align: center;
}

.qrcode-text {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* 加载动画 */
.loading-spinner {
  width: 200px;
  height: 200px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 信息项样式 */
.info-item {
  padding: 16px 20px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: var(--text-secondary);
}

.info-value {
  font-size: 15px;
  color: var(--text-primary);
  font-weight: 500;
  text-align: right;
}

.address-value {
  max-width: 60%;
  word-break: break-word;
}

.refund-value {
  color: var(--danger-color);
}

/* 按钮样式 */
.btn {
  flex: 1;
  padding: 14px 16px;
  border-radius: 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  margin: 0 8px;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: linear-gradient(
    135deg,
    var(--primary-color) 0%,
    var(--primary-dark) 100%
  );
  color: white;
  box-shadow: 0 3px 10px rgba(255, 149, 0, 0.3);
  min-width: 160px;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media screen and (max-width: 320px) {
  .entry-code-section {
    padding: 16px;
    margin: 12px;
  }

  .btn {
    padding: 12px 14px;
    font-size: 15px;
    margin: 0 4px;
  }
}

@media screen and (min-width: 768px) {
  .ticket-entry-container {
    max-width: 500px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    min-height: 100vh;
  }
}

/* 高对比度模式支持 */
@media (prefers-contrast: high) {
  :root {
    --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.2);
    --shadow-medium: 0 4px 16px rgba(0, 0, 0, 0.3);
  }

  .back-btn,
  .btn {
    border: 1px solid currentColor;
  }
}

/* 减少动画的偏好设置 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* 票码列表样式 */
.ticket-list {
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 单个票码项样式 */
.ticket-item {
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-light);
  overflow: hidden;
  position: relative;
  padding: 16px;
  animation: fadeIn 0.3s ease-out;
}

/* 左边票面信息 */
.ticket-info-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding-right: 170px; /* 增大右侧空间以适应更大的二维码 */
}

.ticket-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.title-text {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-tag {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  white-space: nowrap;
}

.status-unused {
  background-color: #e6f7ff;
  color: #1890ff;
}

.status-partial {
  background-color: #fff7e6;
  color: #fa8c16;
}

.status-used {
  background-color: #f6ffed;
  color: #52c41a;
}

.status-unknown {
  background-color: #f5f5f5;
  color: #999999;
}

/* 退票按钮样式 */
.refund-btn {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  white-space: nowrap;
  background-color: #fff2f0;
  color: #ff4d4f;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.refund-btn:active {
  background-color: #ffccc7;
  transform: scale(0.98);
}

.ticket-detail {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-item .label {
  font-size: 13px;
  color: var(--text-secondary);
}

.detail-item .value {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 500;
}

/* 右边票码信息 */
.ticket-info-right {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 150px;
}

.ticket-code {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: all 0.2s ease;
  width: 100%;
  min-width: 150px;
}

.ticket-code:active {
  transform: scale(0.98);
  background-color: #f0f0f0;
}

.code-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.code-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 150px;
  height: 150px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.ticket-qrcode {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.code-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-tertiary);
}

/* 票码放大弹窗 */
.ticket-enlarge-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

.enlarge-content {
  background-color: white;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.enlarge-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}

.enlarge-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.enlarge-close-icon {
  font-size: 24px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.enlarge-close-icon:hover,
.enlarge-close-icon:active {
  color: var(--text-primary);
  background-color: var(--secondary-color);
}

.enlarge-qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.enlarge-qrcode img {
  width: 300px;
  height: 300px;
  object-fit: contain;
}

.enlarge-close {
  padding: 12px 24px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;
}

.enlarge-close:active {
  transform: scale(0.98);
  background-color: var(--primary-dark);
}

/* 触摸反馈增强 */
@media (hover: none) {
  .back-btn,
  .btn,
  .ticket-code {
    touch-action: manipulation;
  }
}

/* 响应式设计 */
@media screen and (max-width: 480px) {
  .ticket-item {
  padding-right: 140px; /* 小屏幕上调整右侧空间 */
}
  
  .ticket-info-left {
    padding-right: 0;
  }
  
  .ticket-info-right {
    position: absolute;
    top: 12px;
    right: 12px;
    min-width: 130px;
    width: auto;
  }
  
  .ticket-code {
    min-width: 130px;
    max-width: 130px;
    padding: 8px;
  }
  
  .code-content {
    width: 100%;
    max-width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    padding: 0;
  }
  
  .enlarge-qrcode img {
    width: 250px;
    height: 250px;
  }
}
</style>
